import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { UtilitiesService } from './utilities.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';
declare let window: any;
declare let gapi: any;
declare var TTDUniversalPixelApi: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Dell India\'s official store locator.';
  public tenantId: string = "1";
  public distance: number = 10000;
  public record: number = 4;
  public reviewsCount: number = 0;
 // public queryParams = ""

  // checks location on/off
  public locationOn = new BehaviorSubject<boolean>(false);
  public latitude!: number;
  public longitude!: number;
  public currentCity: string = "";
  public placeId: string = "";
  // default store listing
  public searchType: string = "s";
  public sourceName: string = "Store Locator"
  isLoad: boolean = false;
  locationOffOn: boolean = false
  isBrowser: boolean;
  distanceForTotalStore: number = 25
  leadForm: boolean = true;
  tenantInfo = {
    "header": {
      "navbar": [
        {
          "displayname": "Sign In",
          "link": "link"
        },
        {
          "displayname": "Latest Offers",
          "icon": "img1.png",
          "link": "link"
        },
        {
          "displayname": "Redeem Offers",
          "icon": "img2.png",
          "link": "link"
        },
        {
          "displayname": "Sing Up",
          "icon": "img2.png",
          "link": "link"
        }
      ],
      "social": {
        "label": "Connect us on",
        "medialink": [{
          "icon": "fbIcon",
          "link": "https:facebook.com/dell"
        },
        {
          "icon": "twIcon",
          "link": "https:twitter.com/dell"
        },
        {
          "icon": "isIcon",
          "link": "https:facebook.com/dell"
        },
        {
          "icon": "ytIcon",
          "link": "https:facebook.com/dell"
        },
        {
          "icon": "ldIcon",
          "link": "https:facebook.com/dell"
        }
        ]
      },
      "logo": "./assets/img/dellLogo.png",
      "contect": {
        "number": "1800 120 2100",
        "label": "Customer Care"
      }
    },
    "main": {
      "mainBanner": "/assets/img/bannerBgImg.png",
      "title": "Dell India's official store locator.",
      "subtitle": "Look for Dell Exclusive Store near you & get automated directions.",
      "desc": "To access closest of the <strong>600+ Dell</strong> Exclusive Stores in India",
      "search": {
        "searchType": ["Stores", "Service Centers"],
        "searchBtnText": "Find Stores",
        "placeholder": "Search Location"
      },
      "location": {
        "title": "View Stores by City",
        "cities": [
          {
            "city": "banglore",
            "img": "assets/public/image/bangalore.png"
          }, {
            "city": "Chennai",
            "img": "assets/public/image/chennai.png"
          },
          {
            "city": "delhi",
            "img": "assets/public/image/delhi.png"
          },
          {
            "city": "Hyderabad",
            "img": "assets/public/image/hyderabad.png"
          },
          {
            "city": "Kolkata",
            "img": "assets/public/image/pune.png"
          },
          {
            "city": "mumbai",
            "img": "assets/public/image/mumbai.png"
          }
        ]
      }
    },
    "sections": [{
      "title": "<strong>New</strong> Products",
      "type": "image",
      "images": [{
        "src": "assets/img/homeProd1.jpg",
        "text": "Be Ready for your new Windows 11 PC"
      },
      {
        "src": "assets/img/prod2.jpg",
        "text": "Windows 11 Gaming: DirectStorage"
      },
      {
        "src": "assets/img/prod1.jpg",
        "text": "Understanding Blue Screen Error Codes"
      }
      ]
    }],
    "multisections": [{
      "title": "<strong>Offers</strong>",
      "mainImg": {
        "title": "Offer<br /> Banners",
        "src": "assets/img/offerbanners.jpg"
      },
      "images": [{
        "src": "assets/img/reviewsBanner.jpg",
        "text": "Reviews"
      },
      {
        "src": "assets/img/reviewsBanner.jpg",
        "text": "Reviews"
      },
      {
        "src": "assets/img/reviewsBanner.jpg",
        "text": "Reviews"
      }
      ]
    },
    {
      "title": "Ace It With",
      "mainImgSrc": "assets/img/acebg.png",
      "images": [{
        "icon": "instDelivery",
        "text": "Instant Delivery"
      },
      {
        "icon": "inPerson",
        "text": "In person assistance"
      },
      {
        "icon": "inAccessories",
        "text": "Genuine accessories"
      }
      ]
    }
    ],
    "footer": {
      "content": "© Dell 2022 . All rights reserved. Dell and the Dell logo are trademarks of Dell in the United States, other countries or both. All Images shown are for Illustrative purposes only,and might not resemble the actual product. Ultrabook, Celeron, Celeron Inside, Core Inside, Intel, Intel Logo, Intel Atom, Intel Atom Inside, Intel Core, Intel Inside, Intel Inside Logo, Intel vPro, Itanium, Itanium Inside, Pentium, Pentium Inside, vPro Inside, Xeon, Xeon Phi, and Xeon Inside are trademarks of Intel Corporation or its subsidiaries in the U.S. and/or other countries.",
      "logo": {
        "src": "assets/img/footerLogo.svg",
        "text": "www.dell.com",
        "href": "https://www.dell.com/en-in?mn=1iDkh2HdV6x7xDCa_-0mV1P7qaQ6lwZdpsPG.ZRp0Tw1uhomQIQq6"
      }

    },
    "faq": [{
      "title": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      "description": "<p> It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker</p>"
    },
    {
      "title": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      "description": "<p> It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker</p>"
    },
    {
      "title": "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      "description": "<p> It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker</p>"
    }
    ],
    "storeListImg": [{
      "title": "<b><span>Store</span></b> The best way to buy the products you love.",
      "className": "storeList",
      "images": [{
        "src": "assets/img/Monitos.png",
        "text": "Monitos"
      },
      {
        "src": "assets/img/Laptops.png",
        "text": "Laptops"
      },
      {
        "src": "assets/img/Desktops.png",
        "text": "Desktops"
      },
      {
        "src": "assets/img/Accessrories.png",
        "text": "Accessrories"
      },
      {
        "src": "assets/img/Servers.png",
        "text": "Servers"
      }
      ]
    },
    {
      "title": "<b><span>Store</span></b> The best way to buy the products you love.",
      "className": "storeList fourCol",
      "images": [{
        "src": "assets/img/gamingDesk.png",
        "text": "Alienware Gaming Desktops"
      },
      {
        "src": "assets/img/gaminkMonitors.png",
        "text": "Gaming Monitors"
      },
      {
        "src": "assets/img/eAccessores.png",
        "text": "Ergonomic Accessorie"
      },
      {
        "src": "/assets/img/backpacks.png",
        "text": "Gaming Backpacks & Cases"
      }
      ]
    },
    {
      "title": "<b><span>New Products and Offers</span></b>Whenever and however you need it.",
      "className": "prodNoffer",
      "images": [{
        "src": "assets/img/prodOffer1.jpg",
        "text": "Shop one on one with a Specialist online."
      },
      {
        "src": "assets/img/prodOffer2.jpg",
        "text": "Service and support. we‘re here to help"
      }
      ]
    }
    ]
  }
  YTOriginUrl: string = "";
  constructor(private apiService: ApiService,
    private route:ActivatedRoute,
    public util: UtilitiesService, @Inject(PLATFORM_ID) platformId: Object,
    private _renderer2: Renderer2,
    private deviceService: DeviceDetectorService,
    @Inject(DOCUMENT) private document: Document ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }


  ngAfterViewInit(): void {
    let MARKETING_SCRIPT_PATH;
    let ANALYTICS_SCRIPT_PATH;
    if (location.hostname == 'dell-stage.hashconnect.in' || location.hostname == 'localhost') {
      ANALYTICS_SCRIPT_PATH = "https://nexus.dell.com/dell/externalDev/Bootstrap.js";
      MARKETING_SCRIPT_PATH = "https://nexus.dell.com/dell/marketingdev/Bootstrap.js";
      this.buildScript(ANALYTICS_SCRIPT_PATH,MARKETING_SCRIPT_PATH);

      this.YTOriginUrl = "https://dell-stage.hashconnect.in";
    } else {
      ANALYTICS_SCRIPT_PATH = "https://nexus.dell.com/dell/external/Bootstrap.js";
      MARKETING_SCRIPT_PATH = "https://nexus.dell.com/dell/marketing/Bootstrap.js";
      this.buildScript(ANALYTICS_SCRIPT_PATH,MARKETING_SCRIPT_PATH);
      this.YTOriginUrl = "https://dell-prod.hashconnect.in";
    }

    this.buildChatBotScript();


  }


  buildChatBotScript() {

    if (location.hostname == 'dell-stage.hashconnect.in' || location.hostname == 'localhost') {
      let id = "gs-sdk";
      let src = "//www.buildquickbots.com/botwidget/v3/demo/static/js/sdk.js?v=3";
      let key = "1ed76598-cf8f-41ae-a8c4-64e5e48330ee";
      let brand = "hashConnectUAT";
      this.buildScriptChatBot(id, src, key, brand);
    } else if
      (location.hostname == 'dellretailstores.in' || location.hostname == 'www.dellretailstores.in') {
      let id = "gs-sdk";
      let src = "//www.buildquickbots.com/botwidget/v3/demo/static/js/sdk.js?v=3";
      let key = "0af29499-df5b-4238-82e4-7f9ea49a995d";
      let brand = "hashConnectPROD";
      this.buildScriptChatBot(id, src, key, brand);

    }
  }
  buildScriptChatBot(id: string, src: string, key: string, brand: string) {
    let scriptTag: any = document.createElement('script');
    scriptTag.src = src;
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.id = id;
    scriptTag.setAttribute("key", key);
    scriptTag.setAttribute("brand", brand);
    document.getElementsByTagName('head')[0].appendChild(scriptTag);

  }

  buildScript(marketingScript: string, analyticsScript: string) {
    let marketing = document.createElement('script');
    marketing.src = marketingScript;
    marketing.type = 'text/javascript';
    marketing.async = true;
    document.getElementsByTagName('head')[0].appendChild(marketing);
    let analytics = document.createElement('script');
    analytics.src = analyticsScript;
    analytics.type = 'text/javascript';
    analytics.async = true;
    document.getElementsByTagName('head')[0].appendChild(analytics);
  }
  hfShow : boolean = true;
  ngOnInit(): void {


    this.apiService.hfSub.subscribe( v =>{
        this.hfShow = v;
    })
    let mobile = this.deviceService.isMobile();
    let tablet = this.deviceService.isTablet();
    let desktop = this.deviceService.isDesktop();

    if (mobile) {
      window['Device'] = "m"
    }
    if (tablet) {
      window['Device'] = "t"
    }
    if (desktop) {
      window['Device'] = "d"
    }

    this.util.loading.subscribe(data => {
      this.isLoad = data
      console.log(data)
    });
    /* if (this.isBrowser) {
      if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('/ngsw-worker.js')
        console.log('Registered as service worker');
      }
    } */
  }
  getDataLayerOnSearch(location:String){
    window.dataLayer.push({ 
 
      event: 'search_location', 
 
      search_query:location, 
       
            }); 
        console.log("dataLayer ", (<any>window).dataLayer);      
  }

  getDataLayervalues(store : any, type : string){
    // (window as any)
    if( type === 'Get_in_touch_store'){
      (<any>window).dataLayer.push({
        event: 'Get_in_touch_store', 
        store_name: store.displayName, 
        store_code:store.contractId, 
        store_address: store.address,   
        store_city : store.city.name,
        store_url : window.location.origin + '/' + store.formattedAddress  
      }) 
   
    }else{
      (<any>window).dataLayer.push({
        event: 'Get_in_touch_product', 
        product_name: store.heading, 
        Product_description: store.text, 
        "Product-price": store.price,
        store_url: window.location.href
      })
    }
    console.log("dataLayer ", (<any>window).dataLayer);
  }

  loadPixelScript(pincode:any, searchLocation:any) {
    debugger
    if (typeof TTDUniversalPixelApi === 'function') {
      // Initialize TTDUniversalPixelApi with dynamic parameters
      var universalPixelApi = new TTDUniversalPixelApi();
      universalPixelApi.init("ev5teqd", ["1tv4i71"], "https://insight.adsrvr.org/track/up", {
        "td1": pincode,
        "td2": searchLocation
      });
    }
  }

}
